import React from 'react';
import * as Router from 'react-router';
import * as RouterDom from 'react-router-dom';

export default {};

export { useLocation } from 'react-router-dom';

export const { Switch } = Router;

export const getRoute = (props: Router.RouteProps) => <Router.Route {...props} />;

export const { BrowserRouter } = RouterDom;

export const { MemoryRouter } = RouterDom;

export const { useHistory } = Router;

export const { withRouter } = Router;

export const { matchPath } = Router;
